import React from 'react'
import Confirm from '../features/checkout/Components/Confirm'

const CheckoutConfirmPage = () => {
    document.title = "Confirm Your Order"
    return (
    <Confirm />
  )
}

export default CheckoutConfirmPage